import script from "./UpcomingOrders.vue?vue&type=script&setup=true&lang=js"
export * from "./UpcomingOrders.vue?vue&type=script&setup=true&lang=js"

import "./UpcomingOrders.vue?vue&type=style&index=0&id=2ef29d06&lang=css"

const __exports__ = script;

export default __exports__